<section class="section skills" [@skillsAnimation] id="skills">
  <div class="container">
    <div class="skills-title">
      <h1 class="big-title">Skills & Technical Expertise</h1>
      <p class="skills-subtitle big-subtitle">
        A Blend of Technical Proficiency and Personal Competencies
      </p>
    </div>
    <div class="skills-grid">
      <div class="skill-card" *ngFor="let skill of skills">
        <div class="skill-icon">
          <i [class]="skill.icon"></i>
        </div>
        <h3 class="skill-name">{{ skill.name }}</h3>
        <p class="skill-description">{{ skill.description }}</p>
      </div>
    </div>
  </div>
</section>
